import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "card-container"
};
const _hoisted_2 = {
  class: "user-container"
};
const _hoisted_3 = {
  class: "avatar-container"
};
const _hoisted_4 = {
  class: "role-nickname"
};
const _hoisted_5 = {
  style: {
    "margin-right": "0.5rem"
  }
};
const _hoisted_6 = {
  key: 0,
  class: "operation-bar"
};
const _hoisted_7 = {
  key: 1,
  class: "operation-bar"
};
const _hoisted_8 = {
  key: 2,
  class: "operation-bar"
};
const _hoisted_9 = {
  key: 3,
  class: "operation-bar"
};
const _hoisted_10 = {
  class: "props-container"
};
const _hoisted_11 = {
  key: 0,
  class: "empty-data-tips"
};
const _hoisted_12 = {
  key: 1,
  class: "props-review-list"
};
import { computed } from 'vue';
import { ElButton, ElImage, ElProgress, ElRow } from 'element-plus';
import PreparedPropCard from "@/components/Stage/PreparedPropCard.vue";
import { gradientPercentageColors } from "@/tools/utils"; // pre-declaration

export default {
  __name: 'StagePropsReviewCard',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  emits: ['update', 'selectedProp'],

  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit; // computed

    const roleLoadValue = computed(() => {
      return props.data.role.load_value ?? 0.0;
    });
    const preparedWeight = computed(() => {
      if (!props.data.props) return 0.0;
      return Object.values(props.data.props).reduce((sum, item) => {
        return sum + item.weight ?? 0.0;
      }, 0.0);
    });
    const loadPercentage = computed(() => {
      if (roleLoadValue.value === 0.0) return 0.0;
      return preparedWeight.value / roleLoadValue.value * 100;
    }); // functions

    const refuseReview = () => {
      if (!props.data) return;
      emits('update', props.data.id, 1);
    };

    const acceptReview = () => {
      if (!props.data) return;
      emits('update', props.data.id, 2);
    };

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_unref(ElRow), {
        style: {
          "align-items": "flex-end",
          "margin-bottom": "12px"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_unref(ElImage), {
          src: __props.data.role.avatar,
          fit: "cover",
          draggable: "false"
        }, null, 8, ["src"])]), _createElementVNode("text", _hoisted_4, _toDisplayString(__props.data.role.nickname), 1)]),
        _: 1
      }), _createVNode(_unref(ElRow), {
        style: {
          "width": "100%",
          "margin-top": "16px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElProgress), {
          color: _unref(gradientPercentageColors),
          percentage: loadPercentage.value,
          "text-inside": true,
          "stroke-width": 16,
          class: "attribute-item-progress load_progress"
        }, {
          default: _withCtx(() => [_createElementVNode("text", _hoisted_5, _toDisplayString(`${preparedWeight.value.toFixed(1)} / ${roleLoadValue.value}`), 1)]),
          _: 1
        }, 8, ["color", "percentage"])]),
        _: 1
      }), _cache[5] || (_cache[5] = _createElementVNode("div", {
        class: "divider"
      }, null, -1)), __props.data.status === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_unref(ElButton), {
        class: "refuse",
        onClick: refuseReview
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode(" 驳回 ", -1)]))]),
        _: 1
      }), _createVNode(_unref(ElButton), {
        onClick: acceptReview
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode(" 接受 ", -1)]))]),
        _: 1
      })])) : __props.data.status === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_unref(ElButton), {
        class: "disabled",
        disabled: true
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode(" 已驳回 ", -1)]))]),
        _: 1
      })])) : __props.data.status === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_unref(ElButton), {
        class: "disabled",
        disabled: true
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode(" 已接受 ", -1)]))]),
        _: 1
      })])) : (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_unref(ElButton), {
        class: "disabled",
        disabled: true
      }, {
        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode(" 未提交 ", -1)]))]),
        _: 1
      })]))]), _createElementVNode("div", _hoisted_10, [!__props.data.props ? (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[6] || (_cache[6] = [_createElementVNode("text", null, "尚未提交道具审查", -1)]))])) : (_openBlock(), _createElementBlock("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data.props, (value, key) => {
        return _openBlock(), _createBlock(PreparedPropCard, {
          key: key,
          data: value,
          onClick: $event => emits('selectedProp', value)
        }, null, 8, ["data", "onClick"]);
      }), 128))]))])]);
    };
  }

};